function resetHierarchyCollections(app, data) {
	app.roleTypes.reset(data['role_types']);
	app.entityTypes.reset(data['entityTypes']);
	app.roles.reset(data['hierarchy_roles']);
	app.committees.reset(data['committees']);
	app.users.reset(data['users']);
	app.entities.reset(data['entities']);
	app.agendaAdmins.reset(data['agenda_admins']);
	app.userRoles.reset(data['user_roles']);

	// reset this last.  this will render the hierarchyView
	app.relationships.reset(data['relationships']);
}

function resetToolboxCollections(app, data) {
	app.roleTypes.reset(data['role_types']);
	app.entityTypes.reset(data['entityTypes']);
	app.committees.reset(data['committees']);
	app.userRoles.reset(data['user_roles']);
	app.entities.reset(data['entities']);
	app.relationships.reset(data['relationships']);
}

function buildHierarchyDropdown(app, elementID) {
	var entityDropdown = new Curriculog.HierarchyDropdownView({
		collection: app.relationships,
		entities: app.entities,
		ineligible: [],
		noAvailableOptionsMessage: 'No eligible entities available',
		id: elementID,
		attributes: {
			name: 'parents'
		},
	});

	var selector = '#' + elementID;
	$(selector).replaceWith(entityDropdown.$el);
}

function setupAccountsList(app, data) {
	resetToolboxCollections(app, data);
	setupToolboxes(app, data);

	populateRoleTypeSelect($('#sort-role-types-available'), app.roleTypes.models);
	buildHierarchyDropdown(app, 'sort-entities-available');
}

function populateRoleTypeSelect($select, models) {
	$select.html('');
	$.each(models, function(index, model){
		$select.append($('<option></option>').attr('value', model.attributes['id']).text(model.attributes['name']));
	});
}

function setupHierarchyList(app, data, cui_enabled) {
	app.hierarchyView = new Curriculog.EntitiesView({
		entities: app.entities,
		collection: app.relationships,
		roles: app.roles,
		committees: app.committees,
		users: app.users,
		userRoles: app.userRoles,
    params: {
      'cui_enabled': cui_enabled
    }
	});

	resetHierarchyCollections(app, data);

	$('#curriculog-hierarchy-column-tabs li.hierarchy-tab').addClass('active')
	var listElement = $('#curriculog-hierarchy-column-content');
	listElement.html(app.hierarchyView.el);
	$('.hierarchy-actions').addClass('active');

	setupToolboxes(app, data);

	hierarchyObject.verticalStretch();
}

function setupToolboxes(app, data) {
	app.hierarchyToolboxView = new Curriculog.HierarchyToolboxView({
		entityTypes: app.entityTypes,
		roleTypes: app.roleTypes,
		committees: app.committees,
	});

	var toolboxElement = $('#curriculog-types-column-content');
	toolboxElement.replaceWith(app.hierarchyToolboxView.el);

	// show only the entity types toolbox on page load
	app.hierarchyToolboxView.entityTypesToolbox.show();

	hierarchyObject.verticalStretch();
}

function closeFlyout(callback) {
	var detailClosed = $('#curriculog-hierarchy-column').outerWidth() - $('#curriculog-summary-column').outerWidth() - 1;
	$('#curriculog-summary-column').animate({'left': detailClosed},
		function () {
			$('.summary.active').removeClass('active');
			$('#curriculog-summary-column').removeClass('active');
			callback && callback();
		}
	);
}

function setupFlyout(type, id, app, callback, cui_enabled) {
	// Cleanup any previous flyout view and it's subviews
	if (app.flyout) {
		app.flyout.cleanup();
	}

	if (type === 'relationship') {
		var relationship = app.relationships.get(id);
		var entityID = relationship.toJSON().entity_id;

		$.ajax({
			type: 'GET',
			url: 'rest/entityflyout/' + id,

			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-summary-column');
				hierarchyObject.unbindFlyoutEvents();
			},

			error: function() {
				message = 'There was an error loading the entity flyout.  '
				message += 'Please try again or contact a system administrator';
				$('#growls').notify('create', 'warning-template', {
					text: message
				});
			},

			success: function (data) {
				var entity = data.entity;
				var entityModel = app.entities.get(entity['id']);
				entityModel.update(entity);

				app.flyout = new Curriculog.EntityFlyoutView({
					currentEntityID: entityID,
					entities: app.entities,
					entityTypes: app.entityTypes,
					relationships: app.relationships,
					roleTypes: app.roleTypes,
					committees: app.committees,
					roles: app.roles,
					entityCanDelete: data.entity_can_delete,
					entityRoleCanDeletes: data.entity_role_can_deletes,
					entityParentsCanDelete: data.entity_parents_can_delete,
          params: {
            cui_enabled: cui_enabled
          }
				});

				$('#curriculog-summary-column-content').html(app.flyout.el);
				hierarchyObject.bindFlyoutEvents();
				callback && callback();
				hierarchyObject.verticalStretch();

				Curriculog.Actions.log('entity-flyout-loaded')

			},

			complete: function () {
				objDom.removeMask('#curriculog-summary-column');
			},
		});

	} else if (type === 'role') {
		$.ajax({
			type: 'GET',
			url: 'rest/roleflyout/' + id,

			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-summary-column');
				hierarchyObject.unbindFlyoutEvents();
			},

			error: function() {
				message = 'There was an error loading the role flyout.  '
				message += 'Please try again or contact a system administrator';
				$('#growls').notify('create', 'warning-template', {
					text: message
				});
			},

			success: function (data) {
				var role = data.role;
				var roleModel = app.roles.get(role['id']);
				roleModel.update(role);

				app.flyout = new Curriculog.RoleFlyoutView({
					currentRoleID: id,
					roles: app.roles,
					roleTypes: app.roleTypes,
					committees: app.committees,
					canDelete: data.role_can_delete,
          params: {
            cui_enabled: cui_enabled
          }
				});

				$('#curriculog-summary-column-content').html(app.flyout.el);
				hierarchyObject.bindFlyoutEvents();
				callback && callback();
				hierarchyObject.verticalStretch();
			},

			complete: function () {
				objDom.removeMask('#curriculog-summary-column');
			},
		});
	} else if (type === 'userRole') {
		$.ajax({
			type: 'GET',
			url: 'rest/userroleflyout/' + id,

			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-summary-column');
				hierarchyObject.unbindFlyoutEvents();
			},

			error: function() {
				message = 'There was an error loading the user role flyout.  '
				message += 'Please try again or contact a system administrator';
				$('#growls').notify('create', 'warning-template', {
					text: message
				});
			},

			success: function (data) {
				var userRole = data.user_role;
				var userRoleModel = app.userRoles.get(userRole['id']);
				userRoleModel.update(userRole);

				app.flyout = new Curriculog.UserRoleFlyoutView({
					userRole: app.userRoles.get(id),
					users: app.users,
					roles: app.roles,
					committees: app.committees,
					agendaAdmins: app.agendaAdmins,
					canDelete: data.user_role_can_delete,
					isAgendaAdmin: data.agenda_admin,
          params: {
            cui_enabled: cui_enabled
          }
				});

				$('#curriculog-summary-column-content').html(app.flyout.el);
				hierarchyObject.bindFlyoutEvents();
				callback && callback();
				hierarchyObject.verticalStretch();
			},

			complete: function () {
				objDom.removeMask('#curriculog-summary-column');
			},
		});
	}

	var newID = 'summary-' + type + '-' + id
	$('#curriculog-summary-column > div:first').attr('id', newID);
}

// Since we are only using the old flyout code in the accounts module, we
// only need to bind and unbind the click events for the user flyout when in the
// accounts module.
function unbindAccountsFlyoutClickEvents(){
	$('#curriculog-summary-column').off('change', '#entities-available');
	$('#curriculog-summary-column').off('click', '#add-role:not(:disabled)');
	$('#curriculog-summary-column').off('click', '#save-user');
	$('#curriculog-summary-column').off('click', '#cancel-user');
	$('#curriculog-summary-column').off('click', '#save-settings:not(:disabled)');
	$('#curriculog-summary-column').off('click', '#cancel-settings:not(:disabled)');
	$('#curriculog-summary-column').off('click', '#save-settings:disabled');
	$('#curriculog-summary-column').off('click', '#cancel-settings:disabled');
	$('#curriculog-summary-column').off('click', '.user-role-remove');
}

// Only do this in the user flyout in the accounts module.
function bindAccountsFlyoutClickEvents(objHierarchy) {
	$('#curriculog-summary-column').on('click', '#save-user', function(event) {
		event.preventDefault();
		if ($('#user-details-id').val() === '0') {
			accountObject.addUser();
		} else {
			accountObject.update($('#user-details-id').val(), 1);
		}
	});

	$('#curriculog-summary-column').on('click', '#cancel-user', function(event) {
		event.preventDefault();
		accountObject.cancelUser($('#user-details-id').val(), 1);
	});

	$('#curriculog-summary-column').on('change', '#entities-available', function(event) {
		accountObject.showRoles($(this).val());
	});

	$('#curriculog-summary-column').on('click', '#add-role:not(:disabled)', function(event) {
		event.preventDefault();
		var userID = $('#user-details-id').val(),
			roleID = $('#entity-roles-available').val(),
			name = $('#entities-available option:selected').text().trim();

		roleID = +roleID.replace('role-available-', '');

		if (roleID) {
			var workload = {
				method_args: {
					user_id: userID,
					role_id: roleID,
				},
			};

			$.ajax({
				type: 'POST',
				url: '/gearman-job.json',
				contentType: 'application/json',
				mask: $('#entity-parents-form').parent().parent(),
				data: JSON.stringify({
					functionName: 'add_role_task',
					workload: workload
				}),
				beforeSend: function () {
					objDom.addMask(this.mask);
				},

				success: function (results) {
					var tmpApp = app;
					getBackgroundJobStatus(results.jobHandle, this.mask, 'Add Role', function (jobResults) {
						var userRoleID = jobResults.result.user_role_id;
						user_role_model = new Curriculog.UserRole({
							'id': userRoleID,
							'user_id': parseInt(userID),
							'role_id': roleID,
						});

						tmpApp.userRoles.add(user_role_model, {silent: true});

						// reload user flyout
						var summaryId = $('.summary').attr('id').match(/summary-(.*)-(.*)/);
						objHierarchy.getFlyout(summaryId[2], summaryId[1]);

						// reload accounts list
						if ($('#curriculog-hierarchy-column-tabs li.active').attr('class').match(/(\w*)-tab/)[1] === 'users') {
							objHierarchy.getAccounts();
						}
						Curriculog.Actions.log('user-role-added');
					},
					function(jobResults){
						var taskName = 'Add Role';
						$('#growls').notify("create","warning-template", {
							title: 'Warning',
							text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
						}, {
							expires: false,
						});
					});
				},

				error: function () {
					objDom.removeMask(this.mask);
				},
			});
		}
	});

	$('#curriculog-summary-column').on('click', '#save-settings:not(:disabled)', function(event) {
		event.preventDefault();
		accountObject.saveSettings($('#user-details-id').val(), 1);
	});

	$('#curriculog-summary-column').on('click', '#save-settings:disabled', function(event) {
		event.preventDefault();
	});

	$('#curriculog-summary-column').on('click', '#cancel-settings:not(:disabled)', function(event) {
		event.preventDefault();
		accountObject.cancelSettings($('#user-details-id').val(), 1);
	});

	$('#curriculog-summary-column').on('click', '#cancel-settings:disabled', function(event) {
		event.preventDefault();
	});

	// User Role Management
	$('#curriculog-summary-column').on('click', '.user-role-remove', function(event) {
		event.preventDefault();

		var accountDetail = $('#account-details-id').val();
		var userId;
		if (accountDetail) {
			userId = accountDetail;
		} else {
			userId = $(this).closest('.summary').attr('id').split('-')[2];
		}
		var roleId = $(this).closest('li').find('input[name="id"]').val();
		var name = $(this).closest('li').find('input[name="name"]').val();

		var userRole = {
			id : roleId,
			userId: userId,
			name: name,
			type: 'user-role'
		};

		accountObject.swapAccountRole(userRole);
	});
}
